import { ModeToggle } from "@/components/mode-toggle";
import LanguageMenu from "@/components/ui/v2/navigation/LanguageMenu";

function AuthNavbar() {
  return (
    <nav className="flex items-center gap-2">
      <ModeToggle />
      <LanguageMenu />
    </nav>
  );
}

export default AuthNavbar;
